module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-nginx-02-jp.5f39c7deccb8d97ede66fcbdf18324dd.png";